import { gql } from '@apollo/client';

export default gql`
  query spaces($page: Int) {
    user {
      canAddSpace
    }
    spaces(page: $page) {
      spacesTotalPages
      spacesTotal
      perPage
      hasNextPage
      currentPage
      spaces {
        id
        name
        role
        usersTotal
      }
    }
    invitedSpaces {
      spacesTotal
    }
  }
`;
